import React, { useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ManagedBy = ({ managedBy, handleChange, xplans, biologists, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="managedBy" className="planField">
            <GroupBDRBiologists />
            <Autocomplete
                name="managedBy"
                multiple
                freeSolo
                autoSelect
                options={biologists}
                value={managedBy ? managedBy.split(",") : []}
                onChange={(_, newValue) => handleChange("managedBy", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={xplanLabels.managedBy}
                        InputLabelProps={{
                            shrink: true,
                            required: required.includes("managedBy")
                        }}
                        required={required.includes("managedBy")}
                    />
                }
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"managedBy"} />}
        </div>
    );
};

export default ManagedBy;
